import * as routing from '../services/routing';
import React, { PureComponent } from 'react';
import Button from '@rezdy/components/Button';
import Form from '@rezdy/components/Form';
import Grid from '@rezdy/components/Grid';
import { H4 } from '@rezdy/components/Heading';
import Layout from './Layout';
import TextStyle from '@rezdy/components/TextStyle';
import routes from '../constants/routes';
import { ErrorMessage } from './ErrorMessage';
import { WithTranslation } from 'react-i18next';

export interface IFormContainerProps extends WithTranslation {
    autoComplete?: boolean;
    context: string;
    data?: any;
    action: (formData: any) => void;
}

export interface IFormState {
    // useRecaptcha: boolean;
    isDirty: boolean;
    isLoading: boolean;
    isSignedIn: boolean;
    message: string;
    data?: any;
    // recaptcha?: boolean;
}

export class AuthRoute<TFormProps extends IFormContainerProps = IFormContainerProps> extends PureComponent<
    TFormProps,
    IFormState
> {
    state = {
        data: {},
        isDirty: false,
        isLoading: false,
        isSignedIn: false,
        message: '',
    };

    onSubmit = (formData: any) => {
        const { action } = this.props;
        const { isLoading } = this.state;

        if (!isLoading) {
            this.setState({ isLoading: true }, async () => {
                try {
                    await action(formData);
                } catch (error) {
                    this.setState({
                        isDirty: true,
                        isLoading: false,
                        message: error.message,
                    });
                }
            });
        }
    };

    renderHeader = () => {
        const { context, i18n } = this.props;
        return (
            <TextStyle align="center">
                <H4>{i18n.t('header', { context })}</H4>
            </TextStyle>
        );
    };

    renderFormMsg = () => {
        const { isDirty, message } = this.state;
        if (message) {
            return <ErrorMessage isDirty={isDirty} as="p" align="center" i18nKey={message}></ErrorMessage>;
        }
        return null;
    };

    // ma
    renderFormFooter = () => {
        const { isLoading } = this.state;
        const { context, i18n } = this.props;
        return (
            <Button type="submit" action="primary" loading={isLoading} width="100%" tight>
                {i18n.t('primaryAction', { context })}
            </Button>
        );
    };

    renderBody = () => {
        return <>Create Body</>;
    };

    onSecondaryClick = () => {
        routing.push(routes.SIGN_IN);
    };

    renderSecondaryAction = () => {
        const { context, i18n } = this.props;
        return (
            <Button action="secondary" onClick={this.onSecondaryClick} reversed tight>
                {i18n.t('secondaryAction', { context })}
            </Button>
        );
    };

    render() {
        const { autoComplete } = this.props;
        const shouldBeOff = autoComplete !== undefined ? (autoComplete ? 'on' : 'off') : 'on';
        return (
            <Layout secondaryAction={this.renderSecondaryAction()}>
                <Form onSubmit={this.onSubmit} autoComplete={shouldBeOff}>
                    <Grid.Container rowGap="32px">
                        {this.renderHeader()}
                        {this.renderFormMsg()}
                        {this.renderBody()}
                        {this.renderFormFooter()}
                    </Grid.Container>
                </Form>
            </Layout>
        );
    }
}

export default AuthRoute;
